import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, headerBuilder, paramBuilder, validateOptions } from '../http';
export var fetchBridgeModelAttributes = function fetchBridgeModelAttributes() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchBridgeModelAttributes', ['modelName'], options);
  return axios.get("".concat(bundle.apiLocation(), "/models/").concat(options.modelName, "/attributes"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridgeModelAttributes: response.data.attributes
    };
  })["catch"](handleErrors);
};
export var fetchBridgeModelAttribute = function fetchBridgeModelAttribute() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchBridgeModelAttribute', ['modelName', 'attributeName'], options);
  var modelName = options.modelName,
      attributeName = options.attributeName;
  return axios.get("".concat(bundle.apiLocation(), "/models/").concat(modelName, "/attributes/").concat(attributeName), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridgeModelAttribute: response.data.attribute
    };
  })["catch"](handleErrors);
};
export var createBridgeModelAttribute = function createBridgeModelAttribute() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('createBridgeModelAttribute', ['modelName', 'bridgeModelAttribute'], options);
  return axios.post("".concat(bundle.apiLocation(), "/models/").concat(options.modelName, "/attributes"), options.bridgeModelAttribute, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridgeModelAttribute: response.data.attribute
    };
  })["catch"](handleErrors);
};
export var updateBridgeModelAttribute = function updateBridgeModelAttribute() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('updateBridgeModelAttribute', ['modelName', 'attributeName', 'bridgeModelAttribute'], options);
  var modelName = options.modelName,
      attributeName = options.attributeName,
      bridgeModelAttribute = options.bridgeModelAttribute;
  return axios.put("".concat(bundle.apiLocation(), "/models/").concat(modelName, "/attributes/").concat(attributeName), bridgeModelAttribute, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridgeModelAttribute: response.data.attribute
    };
  })["catch"](handleErrors);
};
export var deleteBridgeModelAttribute = function deleteBridgeModelAttribute() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('deleteBridgeModelAttribute', ['modelName', 'attributeName'], options);
  var modelName = options.modelName,
      attributeName = options.attributeName;
  return axios["delete"]("".concat(bundle.apiLocation(), "/models/").concat(modelName, "/attributes/").concat(attributeName), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridgeModelAttribute: response.data.attribute
    };
  })["catch"](handleErrors);
};